"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MfaTotpEnrollResponseSchema", {
    enumerable: true,
    get: function() {
        return MfaTotpEnrollResponseSchema;
    }
});
const _zod = require("zod");
const MfaTotpEnrollResponseSchema = _zod.z.object({
    secret: _zod.z.string().min(16),
    otpauthUrl: _zod.z.string().url()
}).strict();
